// ─── Textes écrits par le script, dans la langue de la page ─────────────────
// The site exists in French (src/) and English (src/en/). The few labels this
// file writes itself follow the page's <html lang>.
const TEXT = {
  fr: {
    soundOn: "son on",
    soundOff: "son off",
    soundOnLabel: "Couper le son du showreel",
    soundOffLabel: "Activer le son du showreel",
    close: "Fermer",
    enlarge: "cliquer pour agrandir",
    more: "Afficher plus",
  },
  en: {
    soundOn: "sound on",
    soundOff: "sound off",
    soundOnLabel: "Mute the showreel",
    soundOffLabel: "Turn on the showreel sound",
    close: "Close",
    enlarge: "click to enlarge",
    more: "Show more",
  },
}[document.documentElement.lang === "en" ? "en" : "fr"];

// ─── Effet « lettres brouillées » au survol ─────────────────────────────────
// Au survol d'un titre, d'un lien du menu ou d'un bouton, chaque lettre change
// plusieurs fois au hasard (parmi CHARSET) avant de revenir à la bonne lettre,
// de la première à la dernière. Joue avec les valeurs ci-dessous.
const SCRAMBLE = {
  enabled: true,

  // Lettres tirées au hasard pendant le brouillage.
  charset: "noanoahnoaburgbacher$!",

  // Éléments qui déclenchent l'effet au survol (sélecteurs CSS).
  selector: [
    ".home-title",
    ".project-title",
    ".nav-menu-item a",
    ".home-showreel-button",
    ".project-more-button",
    ".home-sound-toggle",
    ".lang-switch a",
    ".about-link",
    ".end-email",
    ".end-socials a",
    ".end-cv-button",
    ".a-propos-back",
    ".a-propos-search-button",
    ".a-propos-cover a",
    ".a-propos-word",
  ].join(", "),

  // Temps (ms) entre deux changements d'une même lettre. Plus petit = plus rapide.
  changeInterval: 40,

  // Délai (ms) entre le départ d'une lettre et celui de la suivante.
  letterDelay: 33,

  // Nombre de changements par lettre avant qu'elle se fige…
  changes: 3,
  // …plus un nombre aléatoire en plus, entre 0 et cette valeur.
  changesRandom: 2,

  // true : la lettre aléatoire reprend la casse de l'originale (NOAH → OBRA).
  matchCase: true,

  // true : jamais deux fois la même lettre de suite (ni la lettre d'origine).
  avoidRepeat: true,

  // true : toutes les lettres sont brouillées dès le départ, puis se figent
  // une à une. false : elles restent intactes jusqu'à leur tour.
  scrambleBeforeTurn: false,

  // true : un nouveau survol relance l'effet même s'il est en cours.
  restartOnHover: false,

  // true : seulement sur les appareils avec une souris (pas au toucher).
  mouseOnly: true,
};

// ─── Effet « machine à écrire » au scroll ───────────────────────────────────
// Chaque texte qui entre à l'écran s'écrit comme si quelqu'un le tapait :
// curseur |, fautes de frappe corrigées, petites pauses. Un seul texte s'écrit
// à la fois ; les suivants attendent leur tour. Plus il y a de textes en
// attente (l'utilisateur scrolle vite), plus ça accélère, et un texte qui
// sort de l'écran se termine d'un coup — on ne bloque jamais la lecture.
const TYPEWRITER = {
  enabled: true,

  // Textes concernés (sélecteurs CSS). Un élément déjà dans un autre de la
  // liste est ignoré : c'est le parent qui s'écrit, balises comprises.
  selector: [
    ".about-paragraph",
    ".project-title",
    ".project-date",
    ".project-paragraph",
    ".end-title",
    ".end-text",
    ".a-propos-title",
    ".a-propos-lead",
    ".a-propos-search-label",
    ".a-propos-search-text",
    ".a-propos-step-date",
    ".a-propos-step-title",
    ".a-propos-step-text",
    ".a-propos-text",
  ].join(", "),

  // Vitesse de frappe de base, en caractères par minute. (Les fautes et les
  // pauses s'ajoutent, donc la vitesse réelle est un peu plus basse.)
  cpm: 3800,

  // Variation aléatoire de chaque frappe : 0.5 = entre 50 % et 150 % du temps.
  jitter: 0.6,

  // Probabilité d'une faute de frappe par lettre (0.03 = 3 %).
  mistakeChance: 0,
  // Nombre max de lettres tapées en plus avant de remarquer la faute.
  mistakeExtraChars: 3,
  // Pause (ms, [min, max]) quand on remarque la faute, avant d'effacer.
  noticePause: [45, 85],
  // Temps (ms) d'une frappe sur « effacer ».
  backspaceMs: 34,

  // Pause (ms, [min, max]) après une ponctuation (. , ; : ! ? …).
  punctuationPause: [20, 40],
  // Probabilité d'hésiter avant un mot, et durée de l'hésitation (ms).
  wordPauseChance: 0.05,
  wordPause: [10, 30],

  // Pause (ms) avant de commencer un nouveau texte.
  startDelay: 0,

  // Accélération : +100 % de vitesse par texte en attente (1 = +100 %)…
  queueSpeedup: 4,
  // …jusqu'à ce maximum (8 = huit fois plus vite).
  maxSpeed: 12,
  // Nombre de textes en attente « gratuits », qui n'accélèrent pas encore.
  // Un projet qui entre d'un coup met déjà 4–5 textes en file (titre, date,
  // paragraphes) : sans cette marge, le titre partirait déjà en accéléré.
  queueFree: 1,

  // Accélération selon la longueur du texte : au-delà de `lengthFrom`
  // caractères, +lengthSpeedup de vitesse par tranche de 100 caractères
  // (1 = +100 %). Un texte de 400 caractères avec 60 / 1 : ×4,4.
  lengthFrom: 15,
  lengthSpeedup: 8,
  // …jusqu'à ce maximum. Se multiplie avec l'accélération de la file.
  lengthMaxSpeed: 20,

  // Textes plus longs que ça (en caractères) : pas tapés, mais ils
  // apparaissent en se brouillant, lettre après lettre dans le sens de
  // lecture, puis chaque lettre se remet en place.
  scrambleFrom: 40,
  // Temps (ms) pour que toutes les lettres soient apparues.
  scrambleAppear: 350,
  // Après son apparition, chaque lettre se brouille pendant (ms, [min, max]).
  scrambleSettle: [150, 350],
  // Temps (ms) entre deux changements d'une même lettre.
  scrambleInterval: 50,

  // true : un texte qui sort entièrement de l'écran se termine d'un coup.
  finishWhenOffscreen: true,

  // Quand un texte « entre » : ici, quand il dépasse 10 % du bas de l'écran.
  triggerMargin: "10px 0px -10% 0px",
};

// ─── Effet « glitch » aléatoire ─────────────────────────────────────────────
// De temps en temps, sans survol, une lettre ou un mot visible à l'écran se
// brouille un instant, puis revient. La place du texte ne bouge jamais : le
// vrai texte reste en place (invisible) et les lettres brouillées sont
// dessinées par-dessus, chacune centrée sur la lettre qu'elle remplace.
const GLITCH = {
  enabled: true,

  // Textes où ça peut arriver (par défaut : ceux des deux effets ci-dessus).
  selector: `${SCRAMBLE.selector}, ${TYPEWRITER.selector}`,

  // Lettres tirées au hasard.
  charset: SCRAMBLE.charset,

  // Temps (ms, [min, max]) entre deux glitchs.
  every: [150, 700],

  // Probabilité que ce soit un mot entier plutôt qu'une seule lettre.
  wordChance: 0.5,
  // Mots plus longs que ça : on ne brouille qu'une lettre.
  maxWordLength: 12,

  // Temps (ms) entre deux changements d'une même lettre.
  changeInterval: 60,
  // Nombre de changements par lettre, plus 0 à `changesRandom` en plus.
  changes: 3,
  changesRandom: 5,
  // Délai (ms) entre le départ d'une lettre du mot et celui de la suivante.
  letterDelay: 35,

  // true : la lettre aléatoire reprend la casse de l'originale.
  matchCase: true,
};

// ─── Brouillage de toute la page (chargement / changement de page) ──────────
// Au chargement, toutes les lettres visibles arrivent brouillées et se
// remettent en place. En quittant la page pour une autre, elles se brouillent
// pendant le volet vert. Seules les lettres changent (pas les chiffres), et
// rien ne bouge : chaque lettre aléatoire est dessinée sur la vraie.
const PAGE_SCRAMBLE = {
  onLoad: true,
  onLeave: true,

  // Lettres tirées au hasard.
  charset: SCRAMBLE.charset,

  // Temps (ms) entre deux changements d'une même lettre.
  changeInterval: 50,

  // Chargement : chaque lettre se remet en place à un moment entre ces deux
  // valeurs (ms)…
  loadSettle: [200, 1100],
  // …dans cet ordre : "random" (au hasard) ou "reading" (sens de lecture).
  loadOrder: "random",

  // Départ : chaque lettre commence à se brouiller à un moment entre ces deux
  // valeurs (ms). Le volet vert met 600 ms à couvrir l'écran.
  leaveStart: [0, 350],

  // true : la lettre aléatoire reprend la casse de l'originale.
  matchCase: true,
};

// Set by the glitch block at the end: ends any glitch inside an element at
// once, so the hover scramble can take its text nodes over cleanly.
let clearGlitches = () => {};

// Set by the hover-scramble block: ends any hover scramble inside an element
// at once, before another effect wraps the same letters.
let stopHoverScramble = () => {};

// Really visible, not just inside the viewport: the closed burger menu is
// `visibility: hidden` but still sits on screen.
const isShown = (el) =>
  el.checkVisibility
    ? el.checkVisibility({ visibilityProperty: true, opacityProperty: true })
    : true;

// ─── Burger menu : ouverture / fermeture en brouillage ──────────────────────
// À l'ouverture, les liens du menu apparaissent lettre par lettre en se
// brouillant ; à la fermeture, ils se brouillent et disparaissent, puis le
// panneau repart. Seules les lettres changent ; chiffres et tirets
// apparaissent / disparaissent simplement à leur tour.
const MENU_SCRAMBLE = {
  enabled: true,

  // Attente (ms) après le début du glissement du panneau, avant les lettres.
  openDelay: 120,
  // Délai (ms) entre le départ d'un lien et celui du suivant.
  itemDelay: 50,
  // Délai (ms) entre deux lettres d'un même lien.
  charDelay: 18,
  // Durée (ms, [min, max]) pendant laquelle chaque lettre se brouille avant
  // de se figer (ouverture) ou de disparaître (fermeture).
  settle: [120, 350],
  // Temps (ms) entre deux changements d'une même lettre.
  changeInterval: 50,
  // Fermeture plus rapide que l'ouverture : 2 = deux fois plus rapide.
  closeSpeed: 2,

  // Le bouton burger « bugge » pendant qu'il se transforme (☰ ↔ ✕) :
  // durée (ms) du bug…
  burgerGlitchMs: 320,
  // …temps (ms) entre deux sauts…
  burgerGlitchInterval: 40,
  // …décalage max (px) de chaque barre…
  burgerGlitchOffset: 5,
  // …étirement max de chaque barre (0.4 = jusqu'à ±40 % de largeur)…
  burgerGlitchStretch: 0.4,
  // …et probabilité qu'une barre devienne verte à chaque saut.
  burgerGlitchGreen: 0.3,

  // Fond du menu : plusieurs couches qui glissent l'une après l'autre, par
  // à-coups, en buggant. Couleurs, de la première à la dernière (la dernière
  // est le vrai fond du menu, qui reste).
  panelLayers: ["#008000", "#2e2e2e", "rgba(0, 0, 0, 0.95)"],
  // Durée (ms) du glissement d'une couche…
  panelDuration: 320,
  // …nombre d'à-coups pendant ce glissement…
  panelSteps: 5,
  // …et délai (ms) entre une couche et la suivante.
  panelStagger: 70,
  // Bug pendant le glissement : durée (ms), temps entre deux sauts (ms),
  // décalage horizontal max (px), et probabilité qu'une couche soit coupée
  // en bande (un morceau seulement visible) à chaque saut.
  panelGlitchMs: 480,
  panelGlitchInterval: 45,
  panelGlitchOffset: 24,
  panelSliceChance: 0.5,
};

// ─── Curseur qui bugge ──────────────────────────────────────────────────────
// Par moments, le point vert et sa traînée « buggent » : ils se pixellisent
// en gros blocs et des morceaux carrés se décalent. Chaque état bugué tient
// un instant (pas de grésillement image par image). Plus le curseur va vite,
// plus ça arrive souvent.
const CURSOR_GLITCH = {
  enabled: true,

  // Probabilité, à chaque image (~60 par seconde), qu'un bug commence quand
  // le curseur est immobile…
  chance: 0.015,
  // …et en plus quand il bouge à pleine vitesse.
  speedChance: 0.25,
  // Durée (ms, [min, max]) d'un bug.
  burstMs: [150, 380],
  // Pendant un bug, temps (ms) que tient chaque état avant le suivant.
  // Plus grand = moins électrique.
  holdMs: 90,

  // Grille (px) : décalages et blocs tombent sur des multiples de ce pas.
  grid: 8,

  // Pixellisation : taille (px, [min, max]) des gros pixels, et probabilité
  // qu'un état soit pixellisé.
  pixelSize: [8, 16],
  pixelChance: 0.7,

  // Blocs : nombre de morceaux carrés découpés et décalés par état…
  blocks: 2,
  // …taille (px, [min, max])…
  blockSize: [24, 64],
  // …et décalage max (px).
  blockShift: 32,

  // Fantômes : copies décalées du curseur, une par couleur (vide = aucune),
  // par ex. ["rgba(0, 128, 0, 0.5)"]…
  ghostColors: [],
  // …décalées jusqu'à tant de pixels.
  ghostOffset: 24,
};
// ─── Comparaisons qui buggent ───────────────────────────────────────────────
// Sur les comparaisons avant/après (ex. Kinetic Rush), la ligne de coupe se
// déchire un instant en bandes décalées : à l'entrée de la souris, et de temps
// en temps pendant qu'elle bouge.
const COMPARISON_GLITCH = {
  enabled: true,

  // Bug à chaque entrée de la souris (ou du doigt) sur la comparaison.
  onEnter: true,
  // Probabilité de bug à chaque mouvement de souris.
  moveChance: 0.07,

  // Durée (ms, [min, max]) d'un bug, et temps (ms) que tient chaque état.
  burstMs: [140, 300],
  holdMs: 70,

  // Nombre de bandes (min, max) et décalage max de la coupe dans une bande,
  // en % de la largeur.
  bands: [3, 12],
  offset: 1.5,
};

// ─── Images qui buggent ─────────────────────────────────────────────────────
// Les pochettes et affiches de la page À propos se déchirent un instant en
// bandes décalées (parfois une bande verte) : au survol, et de temps en temps
// toutes seules. L'image elle-même ne bouge pas : les bandes sont des copies
// posées par-dessus, retirées à la fin du bug.
const IMAGE_GLITCH = {
  enabled: true,

  // Éléments qui font bugger les images qu'ils contiennent, au survol.
  hover: ".a-propos-cover a",
  // Images qui buggent toutes seules quand elles sont à l'écran ("" = jamais)…
  idle: ".a-propos-cover img",
  // …toutes les tant de ms ([min, max]).
  every: [1500, 4500],

  // Durée (ms, [min, max]) d'un bug, et temps (ms) que tient chaque état.
  burstMs: [160, 340],
  holdMs: 60,

  // Nombre de bandes décalées par état (min, max)…
  slices: [2, 5],
  // …hauteur d'une bande, en % de l'image (min, max)…
  sliceHeight: [4, 22],
  // …et décalage horizontal max (px), arrondi à la grille.
  shift: 16,
  grid: 4,

  // Probabilité, à chaque état, qu'une bande soit verte.
  greenChance: 0.3,
};

// ─── Boutons qui buggent ────────────────────────────────────────────────────
// Au survol, les boutons encadrés buggent pendant qu'ils passent au vert : ils
// sautent de côté par à-coups et, par moments, seule une bande horizontale
// reste visible. Même principe que le fond du menu.
const BOX_GLITCH = {
  enabled: true,

  selector: [
    ".home-showreel-button",
    ".project-more-button",
    ".about-link",
    ".end-cv-button",
    ".a-propos-back",
    ".a-propos-search-button",
  ].join(", "),

  // Durée (ms, [min, max]) d'un bug, et temps (ms) que tient chaque état.
  burstMs: [160, 300],
  holdMs: 45,

  // Décalage horizontal max (px), arrondi à la grille.
  offset: 10,
  grid: 2,
  // Probabilité, à chaque état, que le bouton soit coupé en bande.
  sliceChance: 0.5,

  // true : seulement sur les appareils avec une souris.
  mouseOnly: true,
};

// ─── Volet vert qui bugge ───────────────────────────────────────────────────
// Le volet vert des changements de page bugge pendant qu'il monte : il saute
// de côté et se coupe en bandes, comme le fond du menu.
const PAGE_TRANSITION_GLITCH = {
  enabled: true,

  // Part du glissement (0–1) pendant laquelle il bugge. Il doit être net à la
  // fin, quand il couvre tout l'écran au moment de changer de page.
  until: 0.75,
  // Temps (ms) que tient chaque état.
  holdMs: 45,
  // Décalage horizontal max (px).
  offset: 40,
  // Probabilité, à chaque état, que le volet soit coupé en bande.
  sliceChance: 0.4,
};

// Set by the hero-sound block below; lets the fullscreen showreel handler
// restore the scroll-driven hero volume instead of hard-muting.
let syncHeroAudio = () => {};

// Also set by the hero-sound block: reports whether the visitor has turned
// sound on with the hero's "son on/off" switch. The site starts silent, and
// the fullscreen showreel asks before unmuting, so it stays silent there too
// until the switch is flipped.
let heroSoundAllowed = () => false;

// How long the cursor-following "cliquer pour agrandir" hint stays on screen
// before fading out on its own.
const HINT_VISIBLE_MS = 2000;

// Gallery images are lazy-loaded at low resolution (`data-src` points into
// `img/low/`); the full-size file waits in `data-full-src` until the image is
// opened fullscreen, which is the only place the extra pixels are visible.
// Runs once per element — the attribute is dropped as soon as it is used.
// Gallery videos are not paired this way; they load a single file.
function loadFullResolution(container) {
  container.querySelectorAll("[data-full-src]").forEach((el) => {
    const full = el.getAttribute("data-full-src");
    el.removeAttribute("data-full-src");
    if (!full || el.getAttribute("src") === full) return;
    el.setAttribute("src", full);
  });
}

// Drops every project image/video out of fullscreen. Shared by the Esc key and
// the burger menu, which must never open on top of a fullscreen medium.
function closeFullscreenMedia() {
  document
    .querySelectorAll(".project-image-container.active")
    .forEach((el) => el.classList.remove("active"));
}

// Burger Menu Toggle
document.addEventListener("DOMContentLoaded", () => {
  const burgerMenu = document.querySelector(".home-burger-menu");
  const navMenu = document.querySelector(".nav-menu");
  const body = document.body;

  if (!burgerMenu || !navMenu) return;

  const M = MENU_SCRAMBLE;
  const animated = () => M.enabled && !reducedMotion();
  let anim = null; // { stop() } — the scramble in progress
  let hideTimer;

  // Scrambles every character of the links in ("in": hidden → scrambling →
  // real) or out ("out": real → scrambling → hidden); calls done() at the end.
  function scrambleLinks(mode, done) {
    anim?.stop();
    // Another effect still holding these letters would be wrapped twice and
    // tear the text apart when both unwrap.
    clearGlitches(navMenu);
    stopHoverScramble(navMenu);
    const speed = mode === "out" ? M.closeSpeed : 1;
    const links = [...navMenu.querySelectorAll(".nav-menu-item a")];
    const items = links.map((link, li) => {
      const nodes = [];
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        if (walker.currentNode.nodeValue.trim()) nodes.push(walker.currentNode);
      }
      const { chars, unwrap } = wrapChars(nodes, true);
      const [min, max] = M.settle;
      chars.forEach((c, ci) => {
        c.start =
          ((mode === "in" ? M.openDelay : 0) +
            li * M.itemDelay +
            ci * M.charDelay) /
          speed;
        c.end = c.isLetter
          ? c.start + (min + Math.random() * (max - min)) / speed
          : c.start;
        c.step = -1;
        if (mode === "in") c.span.classList.add("scr--hidden");
      });
      return { chars, unwrap };
    });
    const chars = items.flatMap((item) => item.chars);
    const unwrapAll = () => items.forEach((item) => item.unwrap());
    navMenu.classList.add("is-scrambling");

    let raf;
    const stop = () => {
      cancelAnimationFrame(raf);
      unwrapAll();
      navMenu.classList.remove("is-scrambling");
      anim = null;
    };
    anim = { stop };

    const t0 = performance.now();
    const frame = (now) => {
      const t = now - t0;
      let finished = true;
      chars.forEach((c) => {
        if (t < c.start) {
          finished = false;
          return;
        }
        if (t >= c.end) {
          if (c.step !== Infinity) {
            setScr(c.span, c.original, c.original);
            c.span.classList.toggle("scr--hidden", mode === "out");
          }
          c.step = Infinity;
          return;
        }
        finished = false;
        if (c.step === -1) c.span.classList.remove("scr--hidden");
        const step = Math.floor((t - c.start) / M.changeInterval);
        if (step !== c.step) {
          c.step = step;
          setScr(c.span, scrambleChar(c.original), c.original);
        }
      });
      if (!finished) {
        raf = requestAnimationFrame(frame);
        return;
      }
      // "out" leaves the letters hidden for done(), which unwraps later.
      if (mode === "in") stop();
      else {
        anim = { stop };
        done?.(stop);
        return;
      }
      done?.();
    };
    raf = requestAnimationFrame(frame);
  }

  // The burger's bars jump around (offset, stretch, green flashes) while the
  // CSS morphs ☰ ↔ ✕ in steps. Uses the individual `translate` / `scale`
  // properties, which stack on top of the CSS `transform` instead of
  // replacing it.
  const bars = [...burgerMenu.querySelectorAll("span")];
  let burgerTimer;
  function glitchBurger() {
    clearInterval(burgerTimer);
    burgerMenu.classList.add("is-glitching");
    const t0 = performance.now();
    const jitter = (max) => (Math.random() * 2 - 1) * max;
    burgerTimer = setInterval(() => {
      const over = performance.now() - t0 >= M.burgerGlitchMs;
      bars.forEach((bar) => {
        bar.style.translate = over
          ? ""
          : `${jitter(M.burgerGlitchOffset)}px ${jitter(M.burgerGlitchOffset / 2)}px`;
        bar.style.scale = over ? "" : `${1 + jitter(M.burgerGlitchStretch)} 1`;
        bar.classList.toggle(
          "is-green",
          !over && Math.random() < M.burgerGlitchGreen,
        );
      });
      if (over) {
        clearInterval(burgerTimer);
        burgerMenu.classList.remove("is-glitching");
      }
    }, M.burgerGlitchInterval);
  }

  // Background layers (see .nav-menu-layer in home.scss). Their transition is
  // set here from the config; the delays are flipped for closing, so the
  // last layer to come in is the first to leave.
  const layers = animated()
    ? M.panelLayers.map((color) => {
        const layer = document.createElement("div");
        layer.className = "nav-menu-layer";
        layer.style.background = color;
        layer.style.transition = `transform ${M.panelDuration}ms steps(${M.panelSteps}, jump-end)`;
        return layer;
      })
    : [];
  // Before the list, in order: the first colour at the back, the real
  // background on top.
  navMenu.prepend(...layers);
  if (layers.length) navMenu.classList.add("has-layers");
  const panelMs = M.panelDuration + M.panelStagger * (layers.length - 1);
  navMenu.style.setProperty("--menu-close-ms", `${panelMs}ms`);

  let panelTimer;
  function slidePanel(opening) {
    layers.forEach((layer, i) => {
      const order = opening ? i : layers.length - 1 - i;
      layer.style.transitionDelay = `${order * M.panelStagger}ms`;
    });
    clearInterval(panelTimer);
    const t0 = performance.now();
    const jitter = (max) => (Math.random() * 2 - 1) * max;
    panelTimer = setInterval(() => {
      const over = performance.now() - t0 >= M.panelGlitchMs;
      layers.forEach((layer) => {
        layer.style.translate = over
          ? ""
          : `${jitter(M.panelGlitchOffset)}px 0`;
        if (over || Math.random() >= M.panelSliceChance) {
          layer.style.clipPath = "";
          return;
        }
        // A horizontal band of the layer, the rest cut away.
        const top = Math.random() * 80;
        const height = 5 + Math.random() * (95 - top);
        layer.style.clipPath = `inset(${top}% 0 ${Math.max(0, 100 - top - height)}% 0)`;
      });
      if (over) clearInterval(panelTimer);
    }, M.panelGlitchInterval);
  }

  function openMenu() {
    clearTimeout(hideTimer);
    if (animated()) glitchBurger();
    closeFullscreenMedia();
    burgerMenu.classList.add("active");
    body.classList.add("menu-open");
    navMenu.classList.add("active");
    if (animated()) {
      slidePanel(true);
      scrambleLinks("in");
    }
  }

  function closeMenu() {
    if (!burgerMenu.classList.contains("active")) return;
    burgerMenu.classList.remove("active");
    body.classList.remove("menu-open");
    if (animated()) glitchBurger();
    if (!animated()) {
      navMenu.classList.remove("active");
      return;
    }
    // Letters scramble away first, then the panel slides out; the text is
    // put back once the panel is gone (its slide takes 0.4s, see home.scss).
    scrambleLinks("out", (unwrap) => {
      navMenu.classList.remove("active");
      slidePanel(false);
      hideTimer = setTimeout(unwrap, panelMs);
    });
  }

  burgerMenu.addEventListener("click", () => {
    if (burgerMenu.classList.contains("active")) closeMenu();
    else openMenu();
  });

  // Close menu when clicking on a nav link
  navMenu.querySelectorAll(".nav-menu-item a").forEach((link) => {
    link.addEventListener("click", closeMenu);
  });

  // Close menu when clicking outside
  document.addEventListener("click", (e) => {
    if (
      !burgerMenu.contains(e.target) &&
      !navMenu.contains(e.target) &&
      burgerMenu.classList.contains("active")
    ) {
      closeMenu();
    }
  });
});

// Video Comparison Slider - Reusable Class
class VideoComparisonSlider {
  constructor(container) {
    this.container = container;

    if (!this.container) {
      console.warn(`VideoComparisonSlider: Container not found`);
      return;
    }

    // Query elements relative to this container
    this.slider = this.container.querySelector(".video-comparison-slider");
    this.overlay = this.container.querySelector(".video-comparison-overlay");
    this.mainVideo = this.container.querySelector(".video-comparison-main");
    this.secondaryVideo = this.container.querySelector(
      ".video-comparison-secondary",
    );

    if (!this.slider || !this.container) {
      console.warn(
        `VideoComparisonSlider: Required elements not found in container`,
      );
      return;
    }

    this.init();
  }

  init() {
    this.pct = 50;
    this.glitchTimer = null;
    this.glitchOn =
      COMPARISON_GLITCH.enabled &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.setupEventListeners();
    this.syncVideos();
  }

  // Straight cut at this.pct, or — during a glitch — a torn one: the edge
  // shifted by a random amount in each horizontal band.
  render(torn = false) {
    if (!torn) {
      this.overlay.style.clipPath = `inset(0 ${100 - this.pct}% 0 0)`;
      return;
    }
    const G = COMPARISON_GLITCH;
    const count =
      G.bands[0] + Math.floor(Math.random() * (G.bands[1] - G.bands[0] + 1));
    // Random band boundaries, top to bottom.
    const cuts = Array.from({ length: count - 1 }, () => Math.random() * 100)
      .sort((a, b) => a - b)
      .concat(100);
    const points = ["0% 0%"];
    let top = 0;
    cuts.forEach((bottom) => {
      const x = Math.max(
        0,
        Math.min(100, this.pct + (Math.random() * 2 - 1) * G.offset),
      );
      points.push(`${x}% ${top}%`, `${x}% ${bottom}%`);
      top = bottom;
    });
    points.push("0% 100%");
    this.overlay.style.clipPath = `polygon(${points.join(", ")})`;
  }

  glitch() {
    if (!this.glitchOn || this.glitchTimer) return;
    const G = COMPARISON_GLITCH;
    const until =
      performance.now() +
      G.burstMs[0] +
      Math.random() * (G.burstMs[1] - G.burstMs[0]);
    this.render(true);
    this.glitchTimer = setInterval(() => {
      const over = performance.now() >= until;
      this.render(!over);
      if (over) {
        clearInterval(this.glitchTimer);
        this.glitchTimer = null;
      }
    }, G.holdMs);
  }

  // From a pointer position; keeps the torn look if a glitch is running.
  setFromX(clientX) {
    const rect = this.slider.getBoundingClientRect();
    const pct = ((clientX - rect.left) / rect.width) * 100;
    this.pct = Math.max(0, Math.min(100, pct));
    this.render(Boolean(this.glitchTimer));
  }

  setupEventListeners() {
    this.slider.addEventListener("mousemove", (e) => this.handleMouseMove(e));
    this.slider.addEventListener("mouseleave", () => this.handleMouseLeave());
    this.slider.addEventListener("mouseenter", () => this.handleMouseEnter());

    // Touch support for mobile
    this.slider.addEventListener(
      "touchstart",
      (e) => this.handleTouchStart(e),
      { passive: true },
    );
    this.slider.addEventListener("touchmove", (e) => this.handleTouchMove(e), {
      passive: true,
    });
    this.slider.addEventListener("touchend", () => this.handleTouchEnd());
  }

  handleMouseMove(e) {
    this.setFromX(e.clientX);
    if (Math.random() < COMPARISON_GLITCH.moveChance) this.glitch();
  }

  handleMouseLeave() {
    // Reset overlay opacity on mouse leave
    this.overlay.style.opacity = "0";
  }

  handleMouseEnter() {
    // Set opacity on mouse enter
    this.overlay.style.opacity = "1";
    if (COMPARISON_GLITCH.onEnter) this.glitch();
  }

  handleTouchStart(e) {
    this.overlay.style.opacity = "1";
    this.updateFromTouch(e);
    if (COMPARISON_GLITCH.onEnter) this.glitch();
  }

  handleTouchMove(e) {
    this.updateFromTouch(e);
  }

  handleTouchEnd() {
    this.overlay.style.opacity = "0";
  }

  updateFromTouch(e) {
    if (!e.touches || !e.touches.length) return;
    this.setFromX(e.touches[0].clientX);
  }

  syncVideos() {
    if (!this.mainVideo || !this.secondaryVideo) return;
    if (typeof this.mainVideo.play !== "function") return;

    const OFFSET = 0.15;
    const MAX_DRIFT = 0.12;

    const align = () => {
      this.secondaryVideo.currentTime = this.mainVideo.currentTime + OFFSET;
    };

    // Both videos are lazy-loaded (data-src -> src), so wait until each one
    // actually has data before aligning them and starting them together.
    const startTogether = () => {
      if (this.mainVideo.readyState < 2 || this.secondaryVideo.readyState < 2) {
        return;
      }
      align();
      this.mainVideo.play().catch(() => {});
      this.secondaryVideo.play().catch(() => {});
    };

    this.mainVideo.addEventListener("loadeddata", startTogether);
    this.secondaryVideo.addEventListener("loadeddata", startTogether);
    startTogether();

    // Independent <video> elements drift apart over time; nudge the secondary
    // back onto the main one whenever the gap gets noticeable.
    setInterval(() => {
      if (this.mainVideo.readyState < 2 || this.secondaryVideo.readyState < 2) {
        return;
      }
      const drift =
        this.secondaryVideo.currentTime - (this.mainVideo.currentTime + OFFSET);
      if (Math.abs(drift) > MAX_DRIFT) align();
    }, 2000);
  }
}

// Initialize all video comparison sliders
document.addEventListener("DOMContentLoaded", () => {
  const comparisonSections = document.querySelectorAll(".video-comparison");
  comparisonSections.forEach((section) => {
    new VideoComparisonSlider(section);
  });
});

// Toggle .active on .project-images when clicked
document.addEventListener("DOMContentLoaded", () => {
  const projectImages = document.querySelectorAll(".project-image-container");
  projectImages.forEach((el) => {
    // Every gallery item gets its own close button, styled to only show while
    // the item is fullscreen. Built here rather than in project.html so it
    // covers images, videos and comparison sliders alike.
    const close = document.createElement("button");
    close.type = "button";
    close.className = "project-image-close";
    close.setAttribute("aria-label", TEXT.close);
    close.innerHTML = '<span aria-hidden="true">&#10005;</span>';
    close.addEventListener("click", (e) => {
      // The container itself toggles fullscreen on click — this button only
      // ever closes, so the click must not reach it.
      e.stopPropagation();
      el.classList.remove("active");
    });
    el.appendChild(close);

    el.addEventListener("click", () => {
      const opening = !el.classList.contains("active");
      el.classList.toggle("active");
      // Fetch the full-size file the moment it becomes worth showing.
      if (opening) loadFullResolution(el);
    });
  });
});
// While an item is fullscreen, the arrows step through the rest of its
// gallery: → / ↓ next, ← / ↑ previous, wrapping round at both ends. Only the
// items of the same project are visited.
const GALLERY_STEP = {
  ArrowRight: 1,
  ArrowDown: 1,
  ArrowLeft: -1,
  ArrowUp: -1,
};

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) {
    closeFullscreenMedia();
    return;
  }

  const step = GALLERY_STEP[e.key];
  if (!step || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
  const current = document.querySelector(".project-image-container.active");
  if (!current) return;

  // The page behind must not scroll while the arrows are used for this.
  e.preventDefault();
  const items = [...current.parentElement.children].filter((el) =>
    el.classList.contains("project-image-container"),
  );
  const next =
    items[(items.indexOf(current) + step + items.length) % items.length];
  if (next === current) return;
  // Stepping onto an item still hidden behind « Afficher plus » opens the
  // whole gallery, so the arrows reach every item.
  if (next.hidden) showWholeGallery(current.parentElement);
  current.classList.remove("active");
  next.classList.add("active");
  loadFullResolution(next);
});

// Copies `data-src` to the attribute that actually loads the file. Media in a
// gallery item hidden behind « Afficher plus » is skipped: it loads when the
// item is revealed (showWholeGallery).
function loadLazyMedia(root) {
  root.querySelectorAll("[data-src]").forEach((element) => {
    const dataSrc = element.getAttribute("data-src");
    if (!dataSrc || element.closest("[hidden]")) return;
    // <object> (the documentaire PDF) points at its file with `data`,
    // not `src` — setting `src` on it would do nothing at all.
    const attr = element.tagName === "OBJECT" ? "data" : "src";
    element.setAttribute(attr, dataSrc);
  });
}

// « Afficher plus »: a gallery longer than GALLERY_VISIBLE shows its first
// items only, with a button under it in the style of « Voir le showreel ».
// Built here rather than in project.html so the label follows TEXT, and on
// DOMContentLoaded before the hover scramble and BOX_GLITCH (further down)
// look for their targets.
const GALLERY_VISIBLE = 6;

function showWholeGallery(grid) {
  grid
    .querySelectorAll(":scope > .project-image-container[hidden]")
    .forEach((item) => {
      item.hidden = false;
      loadLazyMedia(item);
    });
  const button = grid.nextElementSibling;
  if (button && button.classList.contains("project-more-button")) {
    button.remove();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".project-images-container").forEach((grid) => {
    const items = grid.querySelectorAll(":scope > .project-image-container");
    if (items.length <= GALLERY_VISIBLE) return;
    items.forEach((item, i) => {
      if (i >= GALLERY_VISIBLE) item.hidden = true;
    });

    const button = document.createElement("button");
    button.type = "button";
    button.className = "project-more-button";
    button.textContent = TEXT.more;
    button.addEventListener("click", () => showWholeGallery(grid));
    grid.after(button);
  });
});

// Lazy load media when .project sections enter viewport
document.addEventListener("DOMContentLoaded", () => {
  const projects = document.querySelectorAll(".project");

  const observerOptions = {
    root: null,
    rootMargin: "50px",
    threshold: 0.1,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadLazyMedia(entry.target);

        // Stop observing this project after loading
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  projects.forEach((project) => {
    observer.observe(project);
  });
});

// The hero's "Voir le showreel" button: the only way into the fullscreen
// showreel. It sits centred in the hero (see home.scss) — the hero itself is
// no longer clickable, so the burger, the sound switch and the title are all
// reachable without a stray click opening the video.
document.addEventListener("DOMContentLoaded", () => {
  const button = document.querySelector(".home-showreel-button");
  if (!button) return;

  const playShowreel = () => {
    // Prefer the high-quality video, fall back to the low-quality one.
    const video =
      document.querySelector(".home-background-video.hq") ||
      document.querySelector(".home-background-video");
    if (!video) return;

    // Entering without sound (or flipping the switch off) means the showreel
    // stays silent here too — fullscreen is not a way around that choice.
    const withSound = heroSoundAllowed();
    video.muted = !withSound;
    if (withSound) video.volume = 1;
    video.controls = true;
    video.currentTime = 0;
    const request =
      video.requestFullscreen ||
      video.webkitRequestFullscreen ||
      video.webkitEnterFullscreen;
    if (request) {
      request.call(video).catch(() => {});
    }
    video.play().catch(() => {});
  };

  // Hide the controls once fullscreen is exited and hand the audio back to
  // the scroll-driven fade (which re-mutes unless the visitor accepted sound).
  const onFullscreenChange = () => {
    if (document.fullscreenElement || document.webkitFullscreenElement) return;
    document.querySelectorAll(".home-background-video").forEach((v) => {
      v.controls = false;
    });
    syncHeroAudio();
  };
  document.addEventListener("fullscreenchange", onFullscreenChange);
  document.addEventListener("webkitfullscreenchange", onFullscreenChange);

  button.addEventListener("click", playShowreel);
});

// "Click to enlarge" hint that follows the cursor while hovering a gallery
// item — shown only until the user clicks an item for the first time.
document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".project-image-container");
  if (!items.length) return;

  let hintDismissed = false;

  const hint = document.createElement("div");
  hint.className = "gallery-hint";
  hint.textContent = TEXT.enlarge;
  document.body.appendChild(hint);

  const isMobile = () => window.innerWidth <= 768;

  let hideTimer = null;
  // Same self-hiding behaviour as the showreel label: once it has timed out it
  // stays hidden until the pointer leaves the item and hovers one again.
  let timedOut = false;

  const hideHint = () => {
    clearTimeout(hideTimer);
    timedOut = false;
    hint.classList.remove("visible");
  };

  const showHint = (e) => {
    if (hintDismissed || isMobile()) return;
    hint.style.left = `${e.clientX}px`;
    hint.style.top = `${e.clientY}px`;
    if (timedOut || hint.classList.contains("visible")) return;

    hint.classList.add("visible");
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      timedOut = true;
      hint.classList.remove("visible");
    }, HINT_VISIBLE_MS);
  };

  items.forEach((el) => {
    el.addEventListener("mousemove", showHint);
    el.addEventListener("mouseleave", hideHint);
    el.addEventListener(
      "click",
      () => {
        // Stop showing the hint once any item has been clicked.
        hintDismissed = true;
        hideHint();
      },
      { once: false },
    );
  });
});

// Custom cursor — a small green dot with a very short fading trail, drawn on
// a fullscreen canvas. Desktop-only: touch devices keep native behaviour, and
// the native cursor is only hidden (see _cursor.scss) under the same media
// query, so there's never a missing cursor.
document.addEventListener("DOMContentLoaded", () => {
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
    return;
  }

  const CURSOR_COLOR = "rgb(0, 90, 0)"; // darker than $green, solid — the
  // trail fades by shrinking, never by opacity.
  const DOT_RADIUS = 6;
  const TRAIL_MS = 150;
  // Hard cap on the trail's length. Without it a fast flick smears an 80ms
  // history over several hundred pixels, which is what made quick movements
  // look bad — past this the tail stops growing and just follows.
  const TRAIL_MAX_PX = 1000;
  // The trail is redrawn each frame from this many evenly-spaced nodes, so
  // the taper is distributed along the *distance* travelled rather than per
  // raw sample — the spacing no longer depends on pointer speed.
  const TRAIL_NODES = 128;
  // Dot and trail swell with pointer speed: 1x at rest, up to MAX_SCALE once
  // the pointer is moving at SPEED_AT_MAX_SCALE or faster.
  const MAX_SCALE = 3;
  const SPEED_AT_MAX_SCALE = 4600; // px per second
  // Per-frame easing of that scale, expressed at 60fps and normalised to the
  // real frame time below — without it the size would snap around frame to
  // frame, since raw pointer speed is very noisy.
  const SCALE_EASE = 0.14;

  const canvas = document.createElement("canvas");
  canvas.className = "custom-cursor-canvas";
  document.body.appendChild(canvas);
  const ctx = canvas.getContext("2d");

  // The canvas backing store has to be sized in *device* pixels, or on a
  // retina display the whole trail is drawn at half resolution and upscaled
  // — which is most of why the edges looked rough.
  const resize = () => {
    const dpr = window.devicePixelRatio || 1;
    canvas.style.width = `${window.innerWidth}px`;
    canvas.style.height = `${window.innerHeight}px`;
    canvas.width = Math.round(window.innerWidth * dpr);
    canvas.height = Math.round(window.innerHeight * dpr);
    // Setting .width/.height resets the transform, so re-apply it after.
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  resize();
  window.addEventListener("resize", resize);

  let points = [];
  // Kept separately so the dot stays exactly under the pointer, and stays put
  // once the trail behind it has fully aged out and emptied the array.
  let current = null;
  let visible = false;
  // True while the pointer sits over an <iframe>/<object>/<embed>, where this
  // document stops receiving pointer events entirely (see below).
  let overEmbed = false;
  // Eased speed-driven size multiplier, and the timestamp it was last eased
  // at (so the easing rate is the same on a 60Hz and a 120Hz display).
  let scale = 1;
  let lastFrame = performance.now();

  // Cursor glitch state (CURSOR_GLITCH, at the top of the file).
  const glitchOn =
    CURSOR_GLITCH.enabled &&
    !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let glitchUntil = 0;
  let glitchState = null;
  // One held glitch state: ghost offsets, pixel size, chunks — everything
  // snapped to the grid, positions relative to the cursor.
  const newGlitchState = (now) => {
    const G = CURSOR_GLITCH;
    const snap = (v) => Math.round(v / G.grid) * G.grid;
    const rand = (max) => (Math.random() * 2 - 1) * max;
    const between = ([min, max]) => min + Math.random() * (max - min);
    return {
      until: now + G.holdMs,
      pixel:
        Math.random() < G.pixelChance ? Math.round(between(G.pixelSize)) : 0,
      ghosts: G.ghostColors.map((color) => ({
        color,
        dx: snap(rand(G.ghostOffset)),
        dy: snap(rand(G.ghostOffset / 2)),
      })),
      blocks: Array.from({ length: G.blocks }, () => {
        const size = snap(between(G.blockSize)) || G.grid;
        return {
          size,
          x: snap(rand(size)) - size / 2,
          y: snap(rand(size)) - size / 2,
          dx: snap(rand(G.blockShift)),
          dy: snap(rand(G.blockShift / 3)),
        };
      }),
    };
  };
  const sliceCanvas = document.createElement("canvas");
  const sliceCtx = sliceCanvas.getContext("2d");

  // The YouTube <iframe> heroes and the <object> PDF viewer are each a
  // SEPARATE document. Pointer events that happen inside one are dispatched
  // in that document and never reach this window, so the dot would otherwise
  // freeze at the embed's edge while the real cursor moves around inside it.
  // There is no fix for that — YouTube is cross-origin and the PDF viewer is
  // the browser's own, so neither can be listened to or styled from here.
  // What we can do is hand over cleanly: hide the dot on the way in and let
  // the embed show its native cursor, which its controls need anyway.
  const EMBED_SELECTOR = "iframe, object, embed";
  const updateOverEmbed = (target) => {
    overEmbed =
      target instanceof Element && target.closest(EMBED_SELECTOR) !== null;
  };

  // Crossing onto an embed fires pointerover on the embed element itself (it
  // is a normal element in THIS document) — the last event we get before the
  // pointer disappears into the nested document.
  document.addEventListener("pointerover", (e) => updateOverEmbed(e.target), {
    passive: true,
  });

  // getCoalescedEvents() hands back the browser/OS's full-rate sample
  // history rather than the one position per frame `mousemove` reports, so
  // the path is dense even during a fast flick.
  //
  // The history is stored in PAGE coordinates (client + scroll) so the trail
  // is anchored to the document and scrolls away with the content, like ink
  // on the page. `current` stays in viewport coordinates — the dot has to
  // track the physical pointer, which scrolling does not move. The two are
  // reconciled in `draw` below.
  window.addEventListener(
    "pointermove",
    (e) => {
      visible = true;
      updateOverEmbed(e.target);
      const events =
        typeof e.getCoalescedEvents === "function"
          ? e.getCoalescedEvents()
          : [e];
      (events.length ? events : [e]).forEach((ev) => {
        points.push({
          x: ev.clientX + window.scrollX,
          y: ev.clientY + window.scrollY,
          t: ev.timeStamp,
        });
      });
      current = { x: e.clientX, y: e.clientY };
    },
    { passive: true },
  );

  // Scrolling moves the pointer through the document without firing a single
  // pointermove, so without this the newest stored point would be left behind
  // on the page and the trail would bridge the gap with one long straight
  // streak. Recording the cursor's page position as the page moves keeps the
  // path continuous — and means a scroll draws a trail of its own.
  window.addEventListener(
    "scroll",
    () => {
      if (!current || overEmbed) return;
      points.push({
        x: current.x + window.scrollX,
        y: current.y + window.scrollY,
        t: performance.now(),
      });
    },
    { passive: true },
  );

  document.addEventListener("mouseleave", () => {
    visible = false;
  });

  // Walks `path` from the cursor backwards and returns `count` points spaced
  // evenly by arc length, stopping at `maxLength`. Even spacing is what lets
  // the taper below be smooth at any speed.
  const resample = (path, count, maxLength) => {
    const cum = [0];
    for (let i = 1; i < path.length; i++) {
      cum.push(
        cum[i - 1] +
          Math.hypot(path[i].x - path[i - 1].x, path[i].y - path[i - 1].y),
      );
    }

    const total = Math.min(cum[cum.length - 1], maxLength);
    if (total < 1) return null;

    const out = [];
    let seg = 1;
    for (let n = 0; n < count; n++) {
      const target = (total * n) / (count - 1);
      while (seg < path.length - 1 && cum[seg] < target) seg++;
      const span = cum[seg] - cum[seg - 1];
      const f = span > 0 ? (target - cum[seg - 1]) / span : 0;
      out.push({
        x: path[seg - 1].x + (path[seg].x - path[seg - 1].x) * f,
        y: path[seg - 1].y + (path[seg].y - path[seg - 1].y) * f,
      });
    }
    return out;
  };

  // Pointer speed in px/s, measured over the whole retained history rather
  // than between the last two samples — individual samples are far too noisy
  // to drive a size off. Returns 0 once the history has aged out, which is
  // what shrinks the cursor back down when the pointer stops.
  //
  // This is speed through the PAGE, not the viewport, so scrolling counts as
  // movement and swells the cursor too — consistent with the trail, which
  // scrolling also draws. Measure `points` against the live scroll offset
  // instead if you ever want the swell to ignore scrolling.
  const pointerSpeed = () => {
    if (points.length < 2) return 0;
    const span = points[points.length - 1].t - points[0].t;
    if (span < 8) return 0;

    let dist = 0;
    for (let i = 1; i < points.length; i++) {
      dist += Math.hypot(
        points[i].x - points[i - 1].x,
        points[i].y - points[i - 1].y,
      );
    }
    return dist / (span / 1000);
  };

  // Fills the trail as ONE tapered polygon. It used to be a stack of
  // individually-stroked round-capped segments, and at speed their widths
  // differed enough from one to the next that the silhouette came out beaded
  // and lumpy. Offsetting each node along its normal and filling the outline
  // in a single path gives a continuous taper instead.
  const fillTrail = (nodes, headRadius) => {
    const last = nodes.length - 1;
    const left = [];
    const right = [];

    for (let i = 0; i <= last; i++) {
      const prev = nodes[Math.max(0, i - 1)];
      const next = nodes[Math.min(last, i + 1)];
      const tx = next.x - prev.x;
      const ty = next.y - prev.y;
      const len = Math.hypot(tx, ty);
      if (len < 0.0001) continue; // degenerate: no direction to offset along

      const radius = headRadius * (1 - i / last);
      const nx = (-ty / len) * radius;
      const ny = (tx / len) * radius;
      left.push({ x: nodes[i].x + nx, y: nodes[i].y + ny });
      right.push({ x: nodes[i].x - nx, y: nodes[i].y - ny });
    }

    if (left.length < 3) return;

    // Both edges are drawn as quadratics through their midpoints so any
    // residual angle between nodes is rounded off. Smoothing the *outline*
    // (rather than the sampled path, as an earlier version did) leaves the
    // head geometry alone, so the tip no longer changes direction a frame
    // after it is drawn.
    const tail = left.length - 1;
    ctx.beginPath();
    ctx.moveTo(left[0].x, left[0].y);
    for (let i = 1; i < tail; i++) {
      ctx.quadraticCurveTo(
        left[i].x,
        left[i].y,
        (left[i].x + left[i + 1].x) / 2,
        (left[i].y + left[i + 1].y) / 2,
      );
    }
    ctx.lineTo(left[tail].x, left[tail].y);
    ctx.lineTo(right[tail].x, right[tail].y);
    for (let i = tail - 1; i >= 1; i--) {
      ctx.quadraticCurveTo(
        right[i].x,
        right[i].y,
        (right[i].x + right[i - 1].x) / 2,
        (right[i].y + right[i - 1].y) / 2,
      );
    }
    ctx.lineTo(right[0].x, right[0].y);
    ctx.closePath();
    ctx.fill();
  };

  const draw = () => {
    requestAnimationFrame(draw);
    const now = performance.now();
    // Clamped so a backgrounded tab doesn't come back with one huge step.
    const dt = Math.min(now - lastFrame, 100);
    lastFrame = now;
    points = points.filter((p) => now - p.t <= TRAIL_MS);

    // Grow with speed, ease back down when the pointer slows or stops. The
    // easing factor is converted from its 60fps value to this frame's real
    // length, so the swell feels identical whatever the refresh rate.
    const target =
      1 + (MAX_SCALE - 1) * Math.min(pointerSpeed() / SPEED_AT_MAX_SCALE, 1);
    scale +=
      (target - scale) * (1 - Math.pow(1 - SCALE_EASE, dt / (1000 / 60)));
    const radius = DOT_RADIUS * scale;

    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    if (!visible || !current) return;

    // Newest first: the trail is built from the cursor backwards in time.
    // The stored points are in page coordinates, so they are converted back
    // to the viewport here — that subtraction is what makes the trail travel
    // with the content when the page scrolls. `current` is already a viewport
    // position, so the path's head lands exactly on the dot.
    const sx = window.scrollX;
    const sy = window.scrollY;
    const path = [current];
    for (let i = points.length - 1; i >= 0; i--) {
      path.push({ x: points[i].x - sx, y: points[i].y - sy });
    }
    const nodes =
      path.length > 1 ? resample(path, TRAIL_NODES, TRAIL_MAX_PX) : null;

    // Glitch bursts (CURSOR_GLITCH): more likely the faster the pointer goes.
    // Each burst is a series of "states" held for holdMs, so it reads as big
    // chunky jumps rather than per-frame static.
    const G = CURSOR_GLITCH;
    if (glitchOn && now >= glitchUntil) {
      const speedRatio = (scale - 1) / (MAX_SCALE - 1);
      if (Math.random() < G.chance + G.speedChance * speedRatio) {
        glitchUntil =
          now + G.burstMs[0] + Math.random() * (G.burstMs[1] - G.burstMs[0]);
        glitchState = null;
      }
    }
    const glitching = glitchOn && now < glitchUntil;
    if (glitching && (!glitchState || now >= glitchState.until)) {
      glitchState = newGlitchState(now);
    }

    // The trail and the dot, optionally offset.
    const drawCursor = (color, dx, dy) => {
      ctx.fillStyle = color;
      if (nodes) {
        fillTrail(
          dx || dy ? nodes.map((n) => ({ x: n.x + dx, y: n.y + dy })) : nodes,
          radius,
        );
      }
      // The dot itself: always drawn at the last known position, even once
      // the trail behind it has fully faded — so it never disappears while
      // the pointer is simply sitting still. Same radius as the trail's head,
      // so it caps that flat edge and the join stays seamless.
      //
      // The one exception is an embed, where the pointer is no longer being
      // reported and the dot would just sit frozen at the boundary. Only the
      // dot is suppressed: the trail drains away on its own over TRAIL_MS.
      if (overEmbed) return;
      ctx.beginPath();
      ctx.arc(current.x + dx, current.y + dy, radius, 0, Math.PI * 2);
      ctx.fill();
    };

    if (glitching) {
      glitchState.ghosts.forEach((g) => drawCursor(g.color, g.dx, g.dy));
    }
    drawCursor(CURSOR_COLOR, 0, 0);
    if (!glitching) return;

    const dpr = window.devicePixelRatio || 1;

    // Big pixels: the whole canvas shrunk down, then blown back up without
    // smoothing.
    if (glitchState.pixel) {
      const step = glitchState.pixel * dpr;
      sliceCanvas.width = Math.ceil(canvas.width / step);
      sliceCanvas.height = Math.ceil(canvas.height / step);
      sliceCtx.drawImage(canvas, 0, 0, sliceCanvas.width, sliceCanvas.height);
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(
        sliceCanvas,
        0,
        0,
        sliceCanvas.width * step,
        sliceCanvas.height * step,
      );
      ctx.restore();
    }

    // Square chunks around the cursor, cut out and pasted back shifted.
    glitchState.blocks.forEach((b) => {
      const x = current.x + b.x;
      const y = current.y + b.y;
      const src = [x * dpr, y * dpr, b.size * dpr, b.size * dpr];
      if (src[0] < 0 || src[1] < 0) return;
      sliceCanvas.width = src[2];
      sliceCanvas.height = src[3];
      sliceCtx.drawImage(canvas, ...src, 0, 0, src[2], src[3]);
      ctx.clearRect(x, y, b.size, b.size);
      ctx.drawImage(sliceCanvas, x + b.dx, y + b.dy, b.size, b.size);
    });
  };
  requestAnimationFrame(draw);
});

// Hero sound. The site starts silent; the "son off/on" switch in the hero is
// the only way to turn sound on. Once on, the volume is driven by scroll,
// reaching silence once the hero has left the viewport.
document.addEventListener("DOMContentLoaded", () => {
  const home = document.querySelector(".home");
  const heroVideos = document.querySelectorAll(".home-background-video");
  if (!heroVideos.length) return;

  let soundAllowed = false;

  // The HQ video replaces the LQ one as soon as it has data; only the one
  // actually on screen should ever be audible, the other stays silent.
  const activeHero = () => {
    const hq = document.querySelector(".home-background-video.hq");
    if (hq && hq.readyState >= 2) return hq;
    return document.querySelector(".home-background-video:not(.hq)");
  };

  // Volume tracks how much of the hero is still on screen: full at the top of
  // the page, silent by the time it has scrolled away.
  const applyHeroVolume = () => {
    // Don't fight the fullscreen showreel, which manages its own audio.
    const fullscreen =
      document.fullscreenElement || document.webkitFullscreenElement;
    if (fullscreen && fullscreen.classList.contains("home-background-video")) {
      return;
    }

    const height = (home && home.offsetHeight) || window.innerHeight;
    const scrolled = window.scrollY || window.pageYOffset || 0;
    const progress = Math.min(Math.max(scrolled / height, 0), 1);
    const volume = soundAllowed ? 1 - progress : 0;
    const active = activeHero();

    heroVideos.forEach((video) => {
      const audible = video === active && volume > 0.01;
      video.volume = audible ? volume : 0;
      video.muted = !audible;
    });
  };

  syncHeroAudio = applyHeroVolume;
  heroSoundAllowed = () => soundAllowed;

  window.addEventListener("scroll", applyHeroVolume, { passive: true });
  window.addEventListener("resize", applyHeroVolume);
  // The LQ→HQ handover changes which video should be audible.
  heroVideos.forEach((video) =>
    video.addEventListener("loadeddata", applyHeroVolume),
  );

  // Small switch in the hero's top-left corner. Flipping it changes what the
  // scroll fade is allowed to play.
  const soundToggle = document.querySelector(".home-sound-toggle");

  const syncSoundToggle = () => {
    if (!soundToggle) return;
    soundToggle.textContent = soundAllowed ? TEXT.soundOn : TEXT.soundOff;
    soundToggle.classList.toggle("muted", !soundAllowed);
    soundToggle.setAttribute("aria-pressed", String(soundAllowed));
    soundToggle.setAttribute(
      "aria-label",
      soundAllowed ? TEXT.soundOnLabel : TEXT.soundOffLabel,
    );
  };

  if (soundToggle) {
    soundToggle.addEventListener("click", (e) => {
      // The hero opens the fullscreen showreel on click — not from here.
      e.stopPropagation();
      soundAllowed = !soundAllowed;
      syncSoundToggle();
      applyHeroVolume();
      if (soundAllowed) {
        // Unmuting is allowed here because we are inside a user gesture.
        heroVideos.forEach((video) => video.play().catch(() => {}));
      }
    });
  }

  applyHeroVolume();
  syncSoundToggle();
});

// Page transition — a green wipe between the site's own pages. Clicking an
// internal link slides a green panel up over the screen, then navigates; the
// next page starts covered (see the inline script in each page's <head>) and
// the panel carries on upward to reveal it. The panel itself is html::after,
// styled in _page-transition.scss. Must match $page-transition-duration.
const PAGE_TRANSITION_MS = 600;

const reducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Slides the green panel up until it covers the screen; resolves once it has.
function coverScreen() {
  const root = document.documentElement;
  if (reducedMotion()) return Promise.resolve();
  root.classList.remove("pt-enter", "pt-reveal");
  root.classList.add("pt-leave");
  glitchPageTransition();
  return new Promise((resolve) => setTimeout(resolve, PAGE_TRANSITION_MS));
}

// From a covered screen, carries the panel on upward and off the top.
function uncoverScreen() {
  const root = document.documentElement;
  root.classList.remove("pt-leave");
  root.classList.add("pt-enter");
  // Two frames so the covered state is painted before the slide starts.
  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      root.classList.add("pt-reveal");
      glitchPageTransition();
      setTimeout(
        () => root.classList.remove("pt-enter", "pt-reveal"),
        PAGE_TRANSITION_MS,
      );
    }),
  );
}

// Runs step() once per held state for a random time within [min, max] ms,
// then end(). Shared by the image, box and page-transition glitches.
function glitchBurst([min, max], holdMs, step, end) {
  const until = performance.now() + min + Math.random() * (max - min);
  step();
  const timer = setInterval(() => {
    if (performance.now() < until) return step();
    clearInterval(timer);
    end();
  }, holdMs);
}

// The green panel jumps sideways and is cut down to a band now and then while
// it slides (PAGE_TRANSITION_GLITCH). Driven through CSS variables on <html>,
// read by html::after in _page-transition.scss — the panel is a pseudo-element.
let pageTransitionGlitching = false;
function glitchPageTransition() {
  const G = PAGE_TRANSITION_GLITCH;
  if (!G.enabled || reducedMotion() || pageTransitionGlitching) return;
  pageTransitionGlitching = true;
  const style = document.documentElement.style;
  const ms = PAGE_TRANSITION_MS * G.until;
  glitchBurst(
    [ms, ms],
    G.holdMs,
    () => {
      style.setProperty(
        "--pt-glitch-x",
        `${Math.round((Math.random() * 2 - 1) * G.offset)}px`,
      );
      if (Math.random() < G.sliceChance) {
        const top = Math.random() * 80;
        const height = 10 + Math.random() * (90 - top);
        style.setProperty(
          "--pt-glitch-clip",
          `inset(${top}% 0 ${Math.max(0, 100 - top - height)}% 0)`,
        );
      } else {
        style.removeProperty("--pt-glitch-clip");
      }
    },
    () => {
      style.removeProperty("--pt-glitch-x");
      style.removeProperty("--pt-glitch-clip");
      pageTransitionGlitching = false;
    },
  );
}

// A page in a sub-folder carries <base href="../"> (see CLAUDE.md), which also
// resolves a bare "#about" against the site root, i.e. to the French home
// page. The English home page has its menu anchors under such a base, so
// same-page anchors are kept on this page here. Registered before the page
// transition below, which then sees the click as handled.
document.addEventListener("click", (e) => {
  const link = e.target.closest('a[href^="#"]');
  if (!link || e.defaultPrevented || !document.querySelector("base[href]")) {
    return;
  }
  const hash = link.getAttribute("href");
  const target = hash.length > 1 && document.getElementById(hash.slice(1));
  if (!target) return;
  e.preventDefault();
  if (location.hash === hash) target.scrollIntoView();
  else location.hash = hash;
});

(() => {
  const root = document.documentElement;

  // Arriving from another page through the wipe: the <head> script has
  // already covered the screen.
  try {
    sessionStorage.removeItem("page-transition");
  } catch (e) {}
  if (root.classList.contains("pt-enter")) uncoverScreen();

  // Coming back through the browser's back button can restore the old page
  // from cache exactly as it was left — fully covered. Wipe it open again.
  window.addEventListener("pageshow", (e) => {
    if (!e.persisted) return;
    // It may also come back with every letter still scrambled.
    unscramblePage();
    if (root.classList.contains("pt-leave")) uncoverScreen();
  });

  document.addEventListener("click", (e) => {
    const link = e.target.closest("a[href]");
    if (
      !link ||
      reducedMotion() ||
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey ||
      e.altKey ||
      (link.target && link.target !== "_self") ||
      link.hasAttribute("download") ||
      link.origin !== location.origin
    ) {
      return;
    }
    // Same-page anchors (the nav menu, the back-to-top arrow) just scroll.
    if (link.pathname === location.pathname && link.hash) return;
    // Files (the CV PDF) are not pages.
    if (!/(\/|\.html)$/.test(link.pathname)) return;

    e.preventDefault();
    try {
      sessionStorage.setItem("page-transition", "1");
    } catch (err) {}
    if (PAGE_SCRAMBLE.onLeave) scramblePageOut();
    coverScreen().then(() => {
      location.href = link.href;
    });
  });
})();

// No dragging images out of the page, nor the links that wrap them (the
// album and poster covers). CSS `-webkit-user-drag` in _base.scss handles
// Chrome and Safari; this catches Firefox and the wrapping links.
document.addEventListener("dragstart", (e) => {
  const target = e.target;
  if (
    target instanceof Element &&
    (target.matches("img, video") || target.querySelector("img, video"))
  ) {
    e.preventDefault();
  }
});

// Lettres brouillées au survol — réglages dans SCRAMBLE, tout en haut.
// Only letters are touched (spaces, punctuation, arrows stay put), and only
// the text nodes' values change, so the element's markup is never rebuilt.
document.addEventListener("DOMContentLoaded", () => {
  if (!SCRAMBLE.enabled || reducedMotion()) return;
  if (SCRAMBLE.mouseOnly && !window.matchMedia("(hover: hover)").matches) {
    return;
  }

  const isLetter = (c) => /\p{L}/u.test(c);
  const running = new Map(); // element → { stop() }
  stopHoverScramble = (root) =>
    running.forEach((r, el) => {
      if (root.contains(el)) r.stop();
    });

  function randomChar(original, previous) {
    const set = SCRAMBLE.charset;
    let c;
    let tries = 0;
    do {
      c = set[Math.floor(Math.random() * set.length)];
    } while (
      SCRAMBLE.avoidRepeat &&
      set.length > 2 &&
      (c === previous || c.toLowerCase() === original.toLowerCase()) &&
      ++tries < 20
    );
    if (!SCRAMBLE.matchCase) return c;
    return original === original.toUpperCase()
      ? c.toUpperCase()
      : c.toLowerCase();
  }

  function scramble(el) {
    // Never scramble a text the typewriter hasn't finished: both rewrite the
    // same text nodes.
    if (el.closest(".tw-pending") || el.querySelector(".tw-pending")) return;
    // The whole page is already scrambling (load / leaving).
    if (document.documentElement.classList.contains("page-scrambling")) return;
    // The burger menu is scrambling its links in or out.
    if (el.parentElement?.closest(".is-scrambling")) return;
    // A random glitch in progress inside it would be snapshotted mid-way.
    clearGlitches(el);
    if (running.has(el)) {
      if (!SCRAMBLE.restartOnHover) return;
      running.get(el).stop();
    }

    // Each letter becomes a `.scr` span (see the page scramble): the real
    // glyph keeps its place and the random one is drawn on top, coloured —
    // so the text never jitters and a wrong letter never passes for a typo.
    const nodes = [];
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      if (isLetter(walker.currentNode.nodeValue))
        nodes.push(walker.currentNode);
    }
    const { chars, unwrap } = wrapChars(nodes, false);
    if (!chars.length) return unwrap();

    const letters = chars.map((c, i) => {
      const changes =
        SCRAMBLE.changes +
        Math.floor(Math.random() * (SCRAMBLE.changesRandom + 1));
      return {
        ...c,
        start: SCRAMBLE.scrambleBeforeTurn ? 0 : i * SCRAMBLE.letterDelay,
        end: i * SCRAMBLE.letterDelay + changes * SCRAMBLE.changeInterval,
        current: c.original,
        step: -1,
      };
    });

    let raf;
    const stop = () => {
      cancelAnimationFrame(raf);
      unwrap();
      running.delete(el);
      el.classList.remove("is-scrambling");
    };
    const t0 = performance.now();
    const frame = (now) => {
      const t = now - t0;
      let done = true;
      letters.forEach((l) => {
        if (t >= l.end) {
          if (l.current !== l.original) setScr(l.span, l.original, l.original);
          l.current = l.original;
          return;
        }
        done = false;
        if (t < l.start) return;
        const step = Math.floor((t - l.start) / SCRAMBLE.changeInterval);
        if (step !== l.step) {
          l.step = step;
          l.current = randomChar(l.original, l.current);
          setScr(l.span, l.current, l.original);
        }
      });
      if (done) stop();
      else raf = requestAnimationFrame(frame);
    };
    el.classList.add("is-scrambling");
    running.set(el, { stop });
    raf = requestAnimationFrame(frame);
  }

  document.querySelectorAll(SCRAMBLE.selector).forEach((el) => {
    el.addEventListener("mouseenter", () => scramble(el));
  });
});

// Machine à écrire au scroll — réglages dans TYPEWRITER, tout en haut.
// Each text node of a target is split in two: the node itself holds what has
// been typed, and a `.tw-rest` span right after it holds the rest, invisible
// but still laid out — so the page never jumps as text appears, and inline
// tags (<strong>, <a>, .green-highlight…) keep their place and style.
document.addEventListener("DOMContentLoaded", () => {
  const T = TYPEWRITER;
  if (!T.enabled || reducedMotion()) return;

  const between = ([min, max]) => min + Math.random() * (max - min);
  const isLetter = (c) => /\p{L}/u.test(c);

  // A plausible wrong key: a neighbour on a Swiss (QWERTZ) keyboard.
  const ROWS = ["qwertzuiop", "asdfghjkl", "yxcvbnm"];
  function typo(c) {
    const lower = c.toLowerCase().normalize("NFD")[0];
    const near = [];
    ROWS.forEach((row, r) => {
      const i = row.indexOf(lower);
      if (i < 0) return;
      near.push(row[i - 1], row[i + 1], ROWS[r - 1]?.[i], ROWS[r + 1]?.[i]);
    });
    const options = near.filter(Boolean);
    const wrong = options.length
      ? options[Math.floor(Math.random() * options.length)]
      : "asdf"[Math.floor(Math.random() * 4)];
    return c === c.toUpperCase() ? wrong.toUpperCase() : wrong;
  }

  // One caret, moved from text to text. Its class flips on every keystroke,
  // which restarts the blink: it stays solid while typing, blinks when idle.
  const caret = document.createElement("span");
  caret.className = "tw-caret";
  caret.setAttribute("aria-hidden", "true");
  let flip = false;
  const bumpCaret = () => {
    flip = !flip;
    caret.classList.toggle("tw-caret--b", flip);
  };

  // Texts already on screen when the page loads are shown as they are, not
  // typed. That covers what is in view now and, until the page has settled,
  // what the browser scrolls to on its own (restored scroll position, #anchor).
  // The phase ends at the first scroll input, or shortly after `load`.
  let loading = true;
  const endLoading = () => (loading = false);
  ["wheel", "touchmove", "keydown", "pointerdown"].forEach((type) =>
    window.addEventListener(type, endLoading, { once: true, passive: true }),
  );
  const afterLoad = () => setTimeout(endLoading, 300);
  if (document.readyState === "complete") afterLoad();
  else window.addEventListener("load", afterLoad, { once: true });

  const inView = (el) => {
    const r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  };

  // Outermost targets only; split their text nodes.
  const jobs = new Map(); // element → segments
  document.querySelectorAll(T.selector).forEach((el) => {
    if (el.parentElement?.closest(T.selector)) return;
    if (inView(el)) return;
    const segs = [];
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const text = node.nodeValue;
      if (!text.trim()) return;
      const rest = document.createElement("span");
      rest.className = "tw-rest";
      rest.textContent = text;
      node.nodeValue = "";
      node.after(rest);
      segs.push({ node, rest, text });
    });
    if (!segs.length) return;
    el.classList.add("tw-pending");
    jobs.set(el, segs);
  });
  if (!jobs.size) return;

  const queue = [];
  let current = null;

  let lengthBoost = 1; // set per text in type()
  const speed = () =>
    Math.min(
      T.maxSpeed,
      1 + Math.max(0, queue.length - T.queueFree) * T.queueSpeedup,
    ) * lengthBoost;
  const sleep = (ms) =>
    new Promise((resolve) => setTimeout(resolve, ms / speed()));
  const keyDelay = () =>
    (60000 / T.cpm) * (1 + (Math.random() * 2 - 1) * T.jitter);

  const offscreen = (el) => {
    const r = el.getBoundingClientRect();
    return r.bottom < 0 || r.top > window.innerHeight;
  };
  const shouldRush = (el) => T.finishWhenOffscreen && offscreen(el);

  // Mistyped keys go in their own coloured span, right before the caret.
  const typoSpan = document.createElement("span");
  typoSpan.className = "tw-typo";

  function render(seg, pos, extra = "") {
    seg.node.nodeValue = seg.text.slice(0, pos);
    if (extra) {
      typoSpan.textContent = extra;
      seg.node.after(typoSpan);
      typoSpan.after(caret);
    } else if (typoSpan.isConnected) {
      typoSpan.remove();
      seg.node.after(caret);
    }
    seg.rest.textContent = seg.text.slice(
      Math.min(seg.text.length, pos + extra.length),
    );
    bumpCaret();
  }

  function finish(el) {
    jobs.get(el).forEach((seg) => {
      seg.node.nodeValue = seg.text;
      seg.rest.remove();
    });
    caret.remove();
    typoSpan.remove();
    el.classList.remove("tw-pending");
    jobs.delete(el);
  }

  // Long texts: show the full text, but each character hidden until its
  // turn (reading order), then scrambling for a moment before it settles.
  // Uses the page scramble's `.scr` spans, so nothing moves. The queue still
  // speeds it up, and leaving the screen ends it at once.
  function scrambleIn(el) {
    const segs = jobs.get(el);
    segs.forEach((seg) => {
      seg.node.nodeValue = seg.text;
      seg.rest.remove();
    });
    caret.remove();
    const { chars, unwrap } = wrapChars(
      segs.map((seg) => seg.node),
      true,
    );
    const queueSpeed = Math.min(
      T.maxSpeed,
      1 + Math.max(0, queue.length - T.queueFree) * T.queueSpeedup,
    );
    const [min, max] = T.scrambleSettle;
    chars.forEach((c, i) => {
      c.span.classList.add("scr--hidden");
      c.appear = ((i / chars.length) * T.scrambleAppear) / queueSpeed;
      c.end = c.isLetter
        ? c.appear + (min + Math.random() * (max - min)) / queueSpeed
        : c.appear;
      c.step = -1;
    });

    return new Promise((resolve) => {
      const t0 = performance.now();
      const frame = (now) => {
        const t = now - t0;
        let done = true;
        chars.forEach((c) => {
          if (t < c.appear) {
            done = false;
            return;
          }
          if (c.step === -1) c.span.classList.remove("scr--hidden");
          if (t >= c.end) {
            if (c.step !== Infinity) setScr(c.span, c.original, c.original);
            c.step = Infinity;
            return;
          }
          done = false;
          const step = Math.floor((t - c.appear) / T.scrambleInterval);
          if (step !== c.step) {
            c.step = step;
            setScr(c.span, scrambleChar(c.original), c.original);
          }
        });
        if (done || shouldRush(el)) {
          unwrap();
          resolve();
        } else requestAnimationFrame(frame);
      };
      requestAnimationFrame(frame);
    });
  }

  // Types one text; returns early (and finish() fills it in) if it leaves
  // the screen mid-way.
  async function type(el) {
    // Visible length: source indentation collapsed, as the browser shows it.
    const length = jobs
      .get(el)
      .map((seg) => seg.text)
      .join("")
      .replace(/\s+/g, " ")
      .trim().length;
    lengthBoost = Math.min(
      T.lengthMaxSpeed,
      1 + (Math.max(0, length - T.lengthFrom) / 100) * T.lengthSpeedup,
    );
    await sleep(T.startDelay);
    if (length > T.scrambleFrom) return scrambleIn(el);
    let started = false;
    for (const seg of jobs.get(el)) {
      seg.node.after(caret);
      let prev = "";
      // A run of digits is one keystroke: a number (a date, a year) is never
      // on screen half-typed, so a screenshot can't catch "202" for "2026".
      for (const m of seg.text.matchAll(/\s+|\d+|./gsu)) {
        if (shouldRush(el)) return;
        const unit = m[0];
        const pos = m.index;
        const next = pos + unit.length;
        const isSpace = !unit.trim();

        // Leading indentation from the HTML source: no keystroke for it.
        if (isSpace && !started) {
          render(seg, next);
          continue;
        }
        started = true;

        if (
          isLetter(unit) &&
          !isLetter(prev) &&
          Math.random() < T.wordPauseChance
        ) {
          await sleep(between(T.wordPause));
        }

        if (isLetter(unit) && Math.random() < T.mistakeChance) {
          // Wrong key, maybe a few right ones after it, notice, erase.
          const extraCount = Math.floor(
            Math.random() * (T.mistakeExtraChars + 1),
          );
          // The extra keys stop before any digit, so a typo never shows
          // part of a number either.
          const after = [...seg.text.slice(next)].slice(0, extraCount);
          const digitAt = after.findIndex((c) => /\d/.test(c));
          const typed = [
            typo(unit),
            ...(digitAt < 0 ? after : after.slice(0, digitAt)),
          ];
          let shown = "";
          for (const c of typed) {
            await sleep(keyDelay());
            shown += c;
            render(seg, pos, shown);
          }
          await sleep(between(T.noticePause));
          while (shown) {
            if (shouldRush(el)) return;
            await sleep(T.backspaceMs * (1 + (Math.random() - 0.5) * T.jitter));
            shown = [...shown].slice(0, -1).join("");
            render(seg, pos, shown);
          }
        }

        await sleep(keyDelay());
        render(seg, next);
        if (/[.,;:!?…]/.test(unit)) await sleep(between(T.punctuationPause));
        prev = unit;
      }
    }
  }

  async function pump() {
    if (current) return;
    while (queue.length) {
      current = queue.shift();
      if (!shouldRush(current)) await type(current);
      finish(current);
      current = null;
    }
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (loading) finish(entry.target);
        else queue.push(entry.target);
      });
      // Several texts can enter at once: type them in reading order.
      queue.sort((a, b) =>
        a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING
          ? -1
          : 1,
      );
      pump();
    },
    { rootMargin: T.triggerMargin },
  );
  jobs.forEach((_, el) => observer.observe(el));
});

// Glitch aléatoire — réglages dans GLITCH, tout en haut.
// The chosen word is wrapped in `.glitch`: its real text stays in a
// `.glitch-src` span (made transparent, so the line keeps its exact layout)
// and each scrambled letter is an absolutely positioned `.glitch-char`
// sitting on the box of the letter it replaces. When done, the wrapper is
// swapped back for the plain text and the text nodes are merged again.
document.addEventListener("DOMContentLoaded", () => {
  const G = GLITCH;
  if (!G.enabled || reducedMotion()) return;

  const active = new Set(); // { wrap, end() }

  clearGlitches = (el) => {
    active.forEach((g) => {
      if (el.contains(g.wrap)) g.end();
    });
  };

  const between = ([min, max]) => min + Math.random() * (max - min);
  const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
  const inView = (el) => {
    const r = el.getBoundingClientRect();
    return (
      r.width > 0 && r.bottom > 0 && r.top < window.innerHeight && isShown(el)
    );
  };
  const busy = (el) =>
    el.closest(".tw-pending, .is-scrambling, .page-scrambling, .glitch") ||
    el.querySelector(".tw-pending, .is-scrambling, .page-scrambling, .glitch");

  function randomChar(original) {
    let c;
    let tries = 0;
    do c = pick(G.charset);
    while (c.toLowerCase() === original.toLowerCase() && ++tries < 10);
    if (!G.matchCase) return c;
    return original === original.toUpperCase()
      ? c.toUpperCase()
      : c.toLowerCase();
  }

  // A random word (or letter) on screen: { node, start, length } or null.
  function chooseTarget() {
    const els = [...document.querySelectorAll(G.selector)].filter(
      (el) => inView(el) && !busy(el),
    );
    if (!els.length) return null;
    const el = pick(els);
    const nodes = [];
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      if (/\p{L}/u.test(walker.currentNode.nodeValue))
        nodes.push(walker.currentNode);
    }
    if (!nodes.length) return null;
    const node = pick(nodes);
    const words = [...node.nodeValue.matchAll(/\p{L}+/gu)];
    const word = pick(words);
    const chars = [...word[0]];
    if (Math.random() < G.wordChance && chars.length <= G.maxWordLength) {
      return { node, start: word.index, length: word[0].length };
    }
    // One letter: find its offset in UTF-16 units within the word.
    const i = Math.floor(Math.random() * chars.length);
    const offset = chars.slice(0, i).join("").length;
    return { node, start: word.index + offset, length: chars[i].length };
  }

  function glitch() {
    const target = chooseTarget();
    if (!target) return;
    const { node, start, length } = target;

    // Isolate the word in its own text node, then wrap it.
    const wordNode = node.splitText(start);
    const after = wordNode.splitText(length);
    const original = wordNode.nodeValue;
    const wrap = document.createElement("span");
    wrap.className = "glitch";
    const src = document.createElement("span");
    src.className = "glitch-src";
    wordNode.before(wrap);
    wrap.append(src);
    src.append(wordNode);

    let raf;
    const g = { wrap, end: () => unwrap() };
    function unwrap() {
      cancelAnimationFrame(raf);
      active.delete(g);
      if (!wrap.isConnected) return;
      // Join the word back with the two halves it was split from — only
      // those: a normalize() would also merge text nodes other effects hold.
      if (node.nextSibling === wrap && wrap.nextSibling === after) {
        node.nodeValue += original + after.nodeValue;
        wrap.remove();
        after.remove();
      } else {
        wrap.replaceWith(document.createTextNode(original));
      }
    }

    // A word that wraps across two lines: leave it alone.
    if (wrap.getClientRects().length !== 1) return unwrap();

    // One overlay per letter, placed on that letter's own box.
    const box = wrap.getBoundingClientRect();
    const range = document.createRange();
    const letters = [];
    let offset = 0;
    [...original].forEach((c) => {
      range.setStart(wordNode, offset);
      range.setEnd(wordNode, offset + c.length);
      offset += c.length;
      const r = range.getBoundingClientRect();
      const span = document.createElement("span");
      span.className = "glitch-char";
      span.setAttribute("aria-hidden", "true");
      span.textContent = c;
      Object.assign(span.style, {
        left: `${r.left - box.left}px`,
        top: `${r.top - box.top}px`,
        width: `${r.width}px`,
        height: `${r.height}px`,
        lineHeight: `${r.height}px`,
      });
      wrap.append(span);
      const i = letters.length;
      const changes =
        G.changes + Math.floor(Math.random() * (G.changesRandom + 1));
      letters.push({
        span,
        original: c,
        start: i * G.letterDelay,
        end: i * G.letterDelay + changes * G.changeInterval,
        step: -1,
      });
    });
    wrap.classList.add("is-glitching");
    active.add(g);

    const t0 = performance.now();
    const frame = (now) => {
      const t = now - t0;
      let done = true;
      letters.forEach((l) => {
        if (t >= l.end) {
          l.span.textContent = l.original;
          l.span.classList.remove("glitch-char--off");
          return;
        }
        done = false;
        if (t < l.start) return;
        const step = Math.floor((t - l.start) / G.changeInterval);
        if (step !== l.step) {
          l.step = step;
          l.span.textContent = randomChar(l.original);
          l.span.classList.add("glitch-char--off");
        }
      });
      if (done) unwrap();
      else raf = requestAnimationFrame(frame);
    };
    raf = requestAnimationFrame(frame);
  }

  const loop = () => {
    if (!document.hidden) glitch();
    setTimeout(loop, between(G.every));
  };
  setTimeout(loop, between(G.every));
});

// Images qui buggent — réglages dans IMAGE_GLITCH, tout en haut.
// A torn image is left untouched: a `.img-glitch` layer is laid exactly over
// it, holding copies of the same picture, each clipped to one horizontal band
// and shifted sideways (styles in _glitch.scss). The layer is removed at the
// end, so nothing about the image or its layout ever changes.
document.addEventListener("DOMContentLoaded", () => {
  const G = IMAGE_GLITCH;
  if (!G.enabled || reducedMotion()) return;

  const between = ([min, max]) => min + Math.random() * (max - min);
  const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
  const shift = () => {
    const px = Math.round(((Math.random() * 2 - 1) * G.shift) / G.grid);
    return (px || (Math.random() < 0.5 ? -1 : 1)) * G.grid;
  };
  // A random horizontal band, for clip-path.
  const band = () => {
    const height = between(G.sliceHeight);
    const top = Math.random() * (100 - height);
    return `inset(${top}% 0 ${100 - top - height}% 0)`;
  };
  const tearing = new Set();

  function tear(img) {
    if (tearing.has(img) || !img.complete || !img.naturalWidth) return;
    // A copy inside a running tear matches the same selectors: leave it.
    if (img.closest(".img-glitch")) return;
    const host = img.parentElement;
    // The layer is placed from the image's offsets, which are only relative
    // to its parent once that parent is positioned.
    if (getComputedStyle(host).position === "static") {
      host.style.position = "relative";
    }
    const { objectFit, objectPosition } = getComputedStyle(img);
    const layer = document.createElement("span");
    layer.className = "img-glitch";
    layer.setAttribute("aria-hidden", "true");
    Object.assign(layer.style, {
      left: `${img.offsetLeft}px`,
      top: `${img.offsetTop}px`,
      width: `${img.offsetWidth}px`,
      height: `${img.offsetHeight}px`,
    });
    const copies = Array.from({ length: G.slices[1] }, () => {
      const copy = document.createElement("img");
      copy.src = img.currentSrc || img.src;
      copy.alt = "";
      Object.assign(copy.style, { objectFit, objectPosition });
      return copy;
    });
    const green = document.createElement("span");
    green.className = "img-glitch-green";
    layer.append(...copies, green);
    host.append(layer);
    tearing.add(img);

    glitchBurst(
      G.burstMs,
      G.holdMs,
      () => {
        const count = Math.round(between(G.slices));
        copies.forEach((copy, i) => {
          copy.style.display = i < count ? "" : "none";
          copy.style.clipPath = band();
          copy.style.translate = `${shift()}px 0`;
        });
        const greenOn = Math.random() < G.greenChance;
        green.style.display = greenOn ? "" : "none";
        if (greenOn) {
          green.style.clipPath = band();
          green.style.translate = `${shift()}px 0`;
        }
      },
      () => {
        layer.remove();
        tearing.delete(img);
      },
    );
  }

  document.querySelectorAll(G.hover).forEach((el) => {
    el.addEventListener("mouseenter", () =>
      el.querySelectorAll("img").forEach(tear),
    );
  });

  if (!G.idle) return;
  const inView = (img) => {
    const r = img.getBoundingClientRect();
    return (
      r.width > 0 && r.bottom > 0 && r.top < window.innerHeight && isShown(img)
    );
  };
  const loop = () => {
    const pageScrambling =
      document.documentElement.classList.contains("page-scrambling");
    if (!document.hidden && !pageScrambling) {
      const imgs = [...document.querySelectorAll(G.idle)].filter(inView);
      if (imgs.length) tear(pick(imgs));
    }
    setTimeout(loop, between(G.every));
  };
  setTimeout(loop, between(G.every));
});

// Boutons qui buggent — réglages dans BOX_GLITCH, tout en haut.
// Inline `translate` / `clip-path`: they stack on top of the CSS `transform`
// (the outlined-button shake) instead of replacing it, and are cleared at the
// end of the burst.
document.addEventListener("DOMContentLoaded", () => {
  const G = BOX_GLITCH;
  if (!G.enabled || reducedMotion()) return;
  if (G.mouseOnly && !window.matchMedia("(hover: hover)").matches) return;

  const running = new Set();
  function glitch(el) {
    if (running.has(el)) return;
    running.add(el);
    glitchBurst(
      G.burstMs,
      G.holdMs,
      () => {
        const px = Math.round(((Math.random() * 2 - 1) * G.offset) / G.grid);
        el.style.translate = `${px * G.grid}px 0`;
        if (Math.random() < G.sliceChance) {
          const top = Math.random() * 60;
          const height = 20 + Math.random() * (80 - top);
          el.style.clipPath = `inset(${top}% 0 ${Math.max(0, 100 - top - height)}% 0)`;
        } else {
          el.style.clipPath = "";
        }
      },
      () => {
        el.style.translate = "";
        el.style.clipPath = "";
        running.delete(el);
      },
    );
  }

  document.querySelectorAll(G.selector).forEach((el) => {
    el.addEventListener("mouseenter", () => glitch(el));
  });
});

// Brouillage de toute la page — réglages dans PAGE_SCRAMBLE, tout en haut.
// Every letter on screen is wrapped in a `.scr` span: its real glyph goes
// transparent (it keeps its exact place in the line) and a ::after draws the
// random letter, read from `data-c`, centred on top. Everything stays in the
// normal flow, so clipping, layering and hover colours keep working.
// Function declarations: the page-transition code above calls them.
let pageScramble = null; // { stop() } while running

// Shows `c` on a `.scr` span; a letter that isn't the real one is coloured
// (`.scr--off`), so a screenshot never shows something that looks like a typo.
function setScr(span, c, original) {
  span.dataset.c = c;
  span.classList.toggle("scr--off", c !== original);
}

function scrambleChar(original) {
  const set = PAGE_SCRAMBLE.charset;
  let c;
  let tries = 0;
  do c = set[Math.floor(Math.random() * set.length)];
  while (c.toLowerCase() === original.toLowerCase() && ++tries < 10);
  if (!PAGE_SCRAMBLE.matchCase) return c;
  return original === original.toUpperCase()
    ? c.toUpperCase()
    : c.toLowerCase();
}

// Wraps every letter of the text on screen; returns them in reading order.
function wrapVisibleLetters() {
  clearGlitches(document.body);
  const skip =
    "script, style, noscript, svg, textarea, select, .tw-pending, .tw-caret, .glitch, .scr";
  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode: (node) =>
        /\p{L}/u.test(node.nodeValue) && !node.parentElement.closest(skip)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT,
    },
  );
  const range = document.createRange();
  const onScreen = (node) => {
    if (!isShown(node.parentElement)) return false;
    range.selectNodeContents(node);
    return [...range.getClientRects()].some(
      (r) => r.width > 0 && r.bottom > 0 && r.top < window.innerHeight,
    );
  };
  const nodes = [];
  while (walker.nextNode()) {
    if (onScreen(walker.currentNode)) nodes.push(walker.currentNode);
  }

  const { chars, unwrap } = wrapChars(nodes, false);
  return { letters: chars, unwrap };
}

// Wraps the letters of these text nodes in `.scr` spans — every visible
// character when `everyChar` is set (spaces stay plain so lines still wrap).
// unwrap() puts the original text nodes back.
function wrapChars(nodes, everyChar) {
  const chars = [];
  const wrapped = [];
  nodes.forEach((node) => {
    const frag = document.createDocumentFragment();
    let plain = "";
    for (const c of node.nodeValue) {
      const isLetter = /\p{L}/u.test(c);
      if (!isLetter && !(everyChar && c.trim())) {
        plain += c;
        continue;
      }
      if (plain) frag.append(plain);
      plain = "";
      const span = document.createElement("span");
      span.className = "scr";
      span.dataset.c = c;
      span.textContent = c;
      frag.append(span);
      chars.push({ span, original: c, isLetter });
    }
    if (plain) frag.append(plain);
    const pieces = [...frag.childNodes];
    node.replaceWith(frag);
    wrapped.push({ node, pieces });
  });

  const unwrap = () =>
    wrapped.forEach(({ node, pieces }) => {
      // The text may have been replaced meanwhile (the sound switch label).
      if (pieces[0].parentNode) pieces[0].before(node);
      pieces.forEach((p) => p.remove());
    });
  return { chars, unwrap };
}

// letters[i].start / .end (ms): when it starts and stops changing.
function runPageScramble(letters, unwrap) {
  pageScramble?.stop();
  const root = document.documentElement;
  root.classList.add("page-scrambling");
  let raf;
  const stop = () => {
    cancelAnimationFrame(raf);
    unwrap();
    root.classList.remove("page-scrambling");
    pageScramble = null;
  };
  pageScramble = { stop };
  const interval = PAGE_SCRAMBLE.changeInterval;
  const t0 = performance.now();
  const frame = (now) => {
    const t = now - t0;
    let done = true;
    letters.forEach((l) => {
      if (t >= l.end) {
        if (!l.settled) setScr(l.span, l.original, l.original);
        l.settled = true;
        return;
      }
      done = false;
      if (t < l.start) return;
      const step = Math.floor((t - l.start) / interval);
      if (step !== l.step) {
        l.step = step;
        setScr(l.span, scrambleChar(l.original), l.original);
      }
    });
    if (done) stop();
    else raf = requestAnimationFrame(frame);
  };
  raf = requestAnimationFrame(frame);
}

function scramblePageIn() {
  const { letters, unwrap } = wrapVisibleLetters();
  if (!letters.length) return unwrap();
  const [min, max] = PAGE_SCRAMBLE.loadSettle;
  letters.forEach((l, i) => {
    const at =
      PAGE_SCRAMBLE.loadOrder === "reading"
        ? i / letters.length + (Math.random() - 0.5) * 0.1
        : Math.random();
    l.start = 0;
    l.end = min + Math.min(1, Math.max(0, at)) * (max - min);
    setScr(l.span, scrambleChar(l.original), l.original); // scrambled from frame one
  });
  runPageScramble(letters, unwrap);
}

function scramblePageOut() {
  if (reducedMotion()) return;
  const { letters, unwrap } = wrapVisibleLetters();
  const [min, max] = PAGE_SCRAMBLE.leaveStart;
  letters.forEach((l) => {
    l.start = min + Math.random() * (max - min);
    l.end = Infinity; // stays scrambled until the next page loads
  });
  runPageScramble(letters, unwrap);
}

function unscramblePage() {
  pageScramble?.stop();
}

document.addEventListener("DOMContentLoaded", () => {
  if (PAGE_SCRAMBLE.onLoad && !reducedMotion()) scramblePageIn();
});
